import { useEffect,useState } from 'react';
import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import useIsFirstRender from '@/hooks/useIsFirstRender';
import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';
import FormCheckbox from '@/shared-components/inputs/components/FormCheckbox';
import LimitedEditionPopup from '@/shared-components/popups/limited-edition';
import Text from '@/shared-components/text/components/Text';

import './styles/RequestLimitedEdition.css';

export default function RequestLimitedEdition({ value, previewMode, unit, height, length, price, typeOfArtwork, onChange, approved, infoIcon=null }) {
  const [open, setOpen] = useState(false);
  const isFirstRender = useIsFirstRender();
  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);

  useEffect(()=>{
    if(!isFirstRender && value) {
      onChange(false);
    }
  }, [unit, height, length, price, typeOfArtwork]);

  const dataNeeded = { unit, height, length, price, typeOfArtwork };

  if(previewMode) {
    return (
      <>
        <div className="request-limited-edition__container">
          <LimitedEditionIcon className="request-limited-edition__limited-edition-icon"/>

          <Text className="request-limited-edition__text" medium>
            {
              value ? 
                "You have requested Limited Editions for this artwork." 
                : 
                "You have not requested Limited Editions for this artwork."
            }
            {infoIcon &&
              <InfoIconArtwork
                className="step-accordeon-step-header__info-icon"
                onClick={(status) => setIsInfoIconOpen(status)}
                open={isInfoIconOpen}
                header={infoIcon.name}
                description={infoIcon.description}
              />
            }
          </Text>
        </div>
      </>
    );
  } else if(typeOfArtwork === "Gallery owned") {
    return (
      <>
        <div className="request-limited-edition__container disabled">
          <LimitedEditionIcon className="request-limited-edition__limited-edition-icon"/>

          <Text className="request-limited-edition__gallery__text" medium>
            Gallery Owned artworks are not eligible for Limited Editions.
            {infoIcon &&
              <InfoIconArtwork
                className="step-accordeon-step-header__info-icon"
                onClick={(status) => setIsInfoIconOpen(status)}
                open={isInfoIconOpen}
                header={infoIcon.name}
                description={infoIcon.description}
              />
            }
          </Text>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className={`request-limited-edition__container element-non-selectable ${(!height || !length || !price) ? "disabled" : ""}`}>
          <div className="public-form-input__checkbox-container">
            <span onClick={() => { setOpen(true); }}>
              <FormCheckbox 
                onClick={() => { 
                  setOpen(true); 
                }}
                className="request-limited-edition__checkbox" 
                element="artwork_limited_edition" 
                readOnly={false}
                value={value} 
                onChange={(_, event) => {
                  event.preventDefault();
                }}
              />
            </span>

            <p className="public-form-input__checkbox-text element-non-selectable">
              <Text className="request-limited-edition__clickable-text" onClick={() => { setOpen(true); }} medium>
                Request Limited Editions 
              </Text>
              <LimitedEditionIcon className="request-limited-edition__limited-edition-icon" 
                onClick={() => { setOpen(true); value ? onChange(false) : ''; }}/>
                    
              {infoIcon &&
                <InfoIconArtwork
                  className="step-accordeon-step-header__info-icon"
                  onClick={(status) => setIsInfoIconOpen(status)}
                  open={isInfoIconOpen}
                  header={infoIcon.name}
                  description={infoIcon.description}
                />
              }

            </p>
          </div>
        </div>
    
        <LimitedEditionPopup 
          requested={value}
          open={open} 
          close={()=>setOpen(false)} 
          onRequest={()=>{ onChange(true); setOpen(false);}} 
          dataNeeded={dataNeeded}
          approved={approved}
        />
      </>
    );
  }
}
